import { useNavigate } from 'react-router-dom';
import { AppShell, Content } from '../../components/ui/AppShell';
import { ArrowRight, ChevronLeft, Lock } from '../../components/ui/icons';
import { useHaptics } from '../../hooks/useHaptics';
import { NationalFlagEmblem } from '../../components/ui/NationalFlagEmblems';
import { leagueWaitingNote, FOCUSED_LEAGUE_ID } from '../../data/leagues';

/** Shown when a player opens a competition that's currently between seasons. */
export function LeagueWaiting({
  leagueId,
  name,
  country
}: {
  leagueId: string;
  name: string;
  country: string;
}) {
  const navigate = useNavigate();
  const { impact } = useHaptics();
  return (
    <AppShell>
      <Content>
        <div className="flex items-center justify-between pt-2 md:pt-5">
          <button
            type="button"
            onClick={() => {
              impact('light');
              navigate('/');
            }}
            className="tap -ml-1 flex items-center gap-[2px] text-ink"
          >
            <ChevronLeft width={22} height={22} strokeWidth={2.4} />
            <span className="text-[16px] font-semibold tracking-snug">Home</span>
          </button>
        </div>

        <div className="flex items-center gap-[13px] pt-3.5">
          <NationalFlagEmblem leagueId={leagueId} country={country} size="lg" muted />
          <div className="flex-1">
            <h1 className="text-[24px] font-extrabold tracking-[-0.025em] leading-[1.05] text-ink">{name}</h1>
            <div className="text-[13px] font-medium text-ink2">{country ? `${country} · ` : ''}Between seasons</div>
          </div>
        </div>

        <div className="mt-6 rounded-[22px] border border-black/8 bg-fill/60 p-[20px]">
          <div className="grid h-[46px] w-[46px] place-items-center rounded-full bg-fill">
            <Lock width={20} height={20} strokeWidth={2.2} className="text-ink3" />
          </div>
          <h2 className="mt-4 text-[18px] font-extrabold tracking-[-0.02em] text-ink">This competition is on a break</h2>
          <p className="mt-1.5 text-[14px] font-medium leading-[1.45] text-ink2">
            {name} {leagueWaitingNote(leagueId).toLowerCase()}. Until then, HeadToHead is all-in on the
            live tournament — build a card on any match each match-day and climb your division.
          </p>
          <button
            type="button"
            onClick={() => {
              impact('medium');
              navigate(`/play/${FOCUSED_LEAGUE_ID}`);
            }}
            className="tap mt-5 flex w-full items-center justify-center gap-2 rounded-[14px] bg-[linear-gradient(140deg,#2EDB7B,#0BA078)] py-[14px] text-[14px] font-extrabold text-white shadow-[0_14px_26px_-12px_rgba(36,197,106,0.55)]"
          >
            Play the live tournament <ArrowRight width={15} height={15} strokeWidth={2.6} />
          </button>
        </div>
      </Content>
    </AppShell>
  );
}
